import { render, staticRenderFns } from "./paoductList.vue?vue&type=template&id=447de64f"
import script from "./paoductList.vue?vue&type=script&lang=js"
export * from "./paoductList.vue?vue&type=script&lang=js"
import style0 from "./css/product-list.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports